import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const DatabaseIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M22 5c0-.9-.5-1.5-1-2-.7-.4-1.4-.8-2.3-1A22 22 0 0 0 12 1a18.6 18.6 0 0 0-8.9 2C2.5 3.5 2 4.1 2 5v14c0 .8.5 1.5 1 2 .7.4 1.4.8 2.3 1 1.8.7 4.1 1 6.7 1a18.6 18.6 0 0 0 8.9-2c.6-.5 1.1-1.2 1.1-2V5ZM4 5c0 .2.2.3.3.4l1.7.8c1.5.5 3.6.8 6 .8a20 20 0 0 0 6-.8l1.7-.8.3-.3V5c0-.2-.2-.3-.3-.4L18 3.8a20 20 0 0 0-6-.8 20 20 0 0 0-6 .8l-1.7.8L4 5Zm16 2.5-1.3.6A22 22 0 0 1 12 9a22 22 0 0 1-8-1.5V12c0 .2.2.3.3.4l1.6.8c1.5.5 3.7.8 6.1.8a20 20 0 0 0 6-.8l1.7-.8.3-.3V7.4Zm0 7-1.3.6a22 22 0 0 1-6.7.9 22 22 0 0 1-8-1.5V19c0 .2.2.3.3.4l1.6.8c1.5.5 3.7.8 6.1.8a20 20 0 0 0 6-.8l1.7-.8.3-.3v-4.6Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default DatabaseIcon;
